import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../store/store';
import { useQuery } from '@tanstack/react-query';
import { getCheckInDataByDate, getCheckInDates } from '../../api/user';
import DatePicker from 'react-datepicker';
import '../../styles/DailyReflection.css';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

export default function DailyReflection() {
    const user = useAuthStore(store => store.user);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [allowedDates, setAllowedDates] = useState([]);
    const [surveyData, setSurveyData] = useState({
        mood: '',
        awareness: '',
        stress: '',
        reappraisal: '',
    });

    const getCheckInDataByDateQuery = useQuery({
        queryKey: ['checkInByDate', user?.uid, selectedDate],
        queryFn: () => getCheckInDataByDate(user?.uid, selectedDate),
    });

    const getCheckInDatesQuery = useQuery({
        queryKey: ['checkInDates', user?.uid],
        queryFn: () => getCheckInDates(user?.uid),
    });

    useEffect(() => {
        if (getCheckInDataByDateQuery.isSuccess && getCheckInDataByDateQuery.data) {
            setSurveyData(getCheckInDataByDateQuery.data);
        }
    }, [getCheckInDataByDateQuery.data]);

    useEffect(() => {
        if (getCheckInDatesQuery.isSuccess) {
            setAllowedDates(getCheckInDatesQuery.data);
        }
    }, [getCheckInDatesQuery.isSuccess, getCheckInDatesQuery.data, getCheckInDatesQuery]);

    const isDateAllowed = (date) => {
        return allowedDates.some(allowedDate => (moment(date).format('YYYY-MM-DD') === allowedDate));
    };

    const CustomDateInput = React.forwardRef(({ value, onChange, onClick }, ref) => (
        <input
            type='text'
            className='input-field'
            name='selectedDate'
            id='selectedDate'
            placeholder="YYYY-MM-DD"
            value={value}
            onClick={onClick}
            onChange={onChange}
            ref={ref}
        />
    ));

    CustomDateInput.displayName = 'CustomDateInput';

    return (
        <div className='daily-reflection-page flex-grow-1 d-flex'>
            <div className="container-fluid h-100">
                <div className='row mt-4'>
                    <div className='col-12 d-flex justify-content-center align-items-center'>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => { setSelectedDate(date); }}
                            dateFormat="yyyy-MM-dd"
                            filterDate={isDateAllowed}
                            customInput={
                                <CustomDateInput
                                    value={selectedDate}
                                    onChange={(e) => { setSelectedDate(e.target.value); }}
                                    onClick={(date) => { setSelectedDate(date); }}
                                />
                            }
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <div className='card p-3 mt-4'>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-3 d-flex'>
                                        <img style={{ height: '4rem', width: '4rem' }} src={'/images/profile-mood.png'} alt='mood' />
                                        <div className='d-flex flex-column justify-content-center align-items-left align-items-sm-center ms-3'>
                                            <h1>Mood</h1>
                                            <h1>{surveyData.mood}</h1>
                                        </div>
                                    </div>
                                    <div className='col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-3 d-flex'>
                                        <img style={{ height: '4rem', width: '4rem' }} src={'/images/profile-awareness.png'} alt='awareness' />
                                        <div className='d-flex flex-column justify-content-center align-items-left align-items-sm-center ms-3'>
                                            <h1>Happy</h1>
                                            <h1>{surveyData.satisfaction}</h1>
                                        </div>
                                    </div>
                                    <div className='col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-3 d-flex'>
                                        <img style={{ height: '4rem', width: '4rem' }} src={'/images/profile-stress.png'} alt='stress' />
                                        <div className='d-flex flex-column justify-content-center align-items-left align-items-sm-center ms-3'>
                                            <h1>Stress</h1>
                                            <h1>{surveyData.stress}</h1>
                                        </div>
                                    </div>
                                    <div className='col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-3 d-flex'>
                                        <img style={{ height: '4rem', width: '4rem' }} src={'/images/profile-reappraisal.png'} alt='reappraisal' />
                                        <div className='d-flex flex-column justify-content-center align-items-left align-items-sm-center ms-3'>
                                            <h1>Tiredness</h1>
                                            <h1>{surveyData.tiredness}</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
